module.exports = __webpack_public_path__ + "favicon.ico?452875c78eb3a3a527c7a06a5166b4b0";